import {
  splitNumber,
  getDemographicText,
  pdfReportHeaderDataUri,
  addPdfFooter,
  getTextSize,
  getUrlParameterByName,
  getDayRangeTitle,
  downLoadCSVFunc,
  pdfReportFooterDataUri,
} from "../../../utils/utility";
import moment from "moment";
import { apiBaseUrl } from "../../../env";

const pdfConverter = require("jspdf");
const html2canvas = require("html2canvas");
let oWidth = 0;
let oWidth2 = 0;
let s = null;

function mapHtml2CanvasWithgmap(eleId) {
  return new Promise((resolve, reject) => {
    const ele = document.getElementById(eleId);
    oWidth = oWidth || ele.offsetWidth;
    ele.style.width = "1024px";
    setTimeout(() => {
      var gmStyle = document.getElementsByClassName("gm-style");
      const p = gmStyle[0].childNodes[0].childNodes[0];
      const t = p.childNodes[4].childNodes[0];
      const t1 = p.childNodes[0].childNodes[0].childNodes[0];
      const t2 = p.childNodes[1].childNodes[0].childNodes[0];
      [t, t1, t2].forEach(o => {
        if (o) {
          const transform = o.style.transform;
          var comp = transform.split(","); //split up the transform matrix
          var mapleft = parseFloat(comp[4]); //get left value
          var maptop = parseFloat(comp[5]); //get top value
          o.style.transform = "none";
          o.style.left = mapleft + "px";
          o.style.top = maptop + "px";
        }
      });
      html2canvas(ele, {
        proxy: `${apiBaseUrl}/proxy/images`,
        logging: false,
        svgRendering: true,
        useCORS: true,
        allowTraint: false,
      })
        .then(canvas => {
          ele.style.width = oWidth + "px";
          resolve({ canvas });
        })
        .catch(reject);
    }, 2000);
  });
}
function mapHtml2Canvas(eleId) {
  return new Promise((resolve, reject) => {
    const ele = document.getElementById(eleId);
    oWidth = oWidth || ele.offsetWidth;
    ele.style.width = "1024px";
    setTimeout(() => {
      html2canvas(ele, { logging: false })
        .then(canvas => {
          ele.style.width = oWidth + "px";
          resolve({ canvas });
        })
        .catch(reject);
    }, 200);
  });
}

function mapHtml2Canvas2(ele) {
  return new Promise((resolve, reject) => {
    ele.style.width = "500px";
    setTimeout(() => {
      html2canvas(ele, { logging: false })
        .then(canvas => {
          resolve({ canvas });
        })
        .catch(reject);
    }, 200);
  });
}

function createFilename(d, type, popUrl, BusinessUnit) {
  const { client_tags, websiteId } = this.props;
  const tag = client_tags
    ? client_tags.find(it => +it.id === +websiteId)
    : null;
  const domain = tag && tag.domain ? tag.domain : "Unknown";
  const dayRange = this.getDayRangeTitle(d).replace(/\s+/g, "");
  const time = moment().format("YYYYMMDD");
  if (popUrl) {
    type = popUrl.replace(/^\/|\/$/, "").replace(/\//g, "_");
  }
  return `${
    BusinessUnit ? BusinessUnit + "_" : ""
  }${domain}_${dayRange}_${type}_${time}.pdf`;
}

function _addPdfFooter(pdf, pageHeight) {
  pdf.setFillColor(127, 127, 127);
  const top = pageHeight - 12;
  pdf.rect(0, top, 210, 15, "F");
  pdf.addImage(pdfReportFooterDataUri(), "PNG", 15, top + 3, 20, 0);
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.setFontType("bold");
  pdf.text(
    65,
    top + 6,
    "Copyright © " +
      moment().format("YYYY") +
      " Claritas, LLC. All rights reserved",
  );
}

export default function downloadAsPdf(nav) {
  const { reportType } = this.props;
  const popUrl = getUrlParameterByName("pop_url");
  this.setState({
    showLoadingDialog: true,
    pdfCreating: true,
    showDownloadDialog: false,
  });
  const {
    selected_client,
    client_sites,
    websiteId,
    clients,
    client_info,
    dayRange,
  } = this.props;

  let bu_name = "";
  if (client_info.parentClientId) {
    const parent_client = clients.find(c => {
      return parseInt(c.id, 10) === parseInt(client_info.parentClientId, 10);
    });
    if (parent_client) {
      // client_name = parent_client.name;
      bu_name = client_info.name;
    }
  }
  let c = clients.find(function(client) {
    return parseInt(client.id, 10) === parseInt(selected_client, 10);
  });
  if (!c) {
    clients.forEach(function(cl) {
      if (cl.businessUnits) {
        cl.businessUnits.forEach(function(b) {
          if (parseInt(b.id, 10) === parseInt(selected_client, 10)) c = b;
        });
      }
    });
  }

  const clientName = c && c.name ? c.name : "";

  s = client_sites.find(function(site) {
    return site.value === websiteId;
  });
  let pdf = null;
  const isBusiness = this.props.reportType === "business";
  let className = "overview-dashboard";
  if (isBusiness && nav === "overflow") {
    className = "overview-dashboard";
  }
  var main = document.getElementById(className);
  let pageHeight = 0;
  if ((popUrl && nav === "pop") || (isBusiness && nav !== "map")) {
    var serviceContact = document.getElementById("service-contact");
    if (serviceContact) serviceContact.style.display = "none";
    pageHeight = main.offsetHeight / (main.offsetWidth / 230) + 10;
    pdf = new pdfConverter("p", "mm", [210, pageHeight]);
  } else {
    pdf = new pdfConverter("p", "mm", "a4");
  }
  pdf.setFont("helvetica");
  pdf.setFontType("normal");
  pdf.setFontSize(9);

  pdf.setFillColor(127, 127, 127);
  pdf.rect(0, 15, 210, 10, "F");

  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(9);
  pdf.setFontType("bold");
  pdf.addImage(pdfReportHeaderDataUri(), "PNG", 10.5, 3, 60, 0);
  pdf.text(198, 8, moment().format("MMMM DD, YYYY"), null, null, "right");

  pdf.setTextColor(255, 255, 255);
  pdf.setFontType("bold");
  const textTop = 21;
  pdf.text(12, textTop, "Client:");
  const lenClientName = getTextSize(clientName.trim(), "helvetica");
  pdf.setFontType("normal");
  pdf.text(23, textTop, clientName.trim());
  //cm to inches
  if (bu_name) {
    let start = 23 + lenClientName.width * 0.3937 + 3.4;
    pdf.setFontType("bold");
    pdf.text(start, textTop, "Business Unit:");
    start += 24.5;
    pdf.setFontType("normal");
    pdf.text(start, textTop, bu_name.trim());
  }
  // pdf.setFontType('bold')
  // pdf.text(start, textTop, 'Date:')
  // pdf.setFontType('normal')
  // start += (getTextSize('Date:', 'helvetica')).width * 0.3937 + 0.4
  // pdf.text(start, textTop, this.getDayRangeTitle(dayRange))
  pdf.setTextColor(0, 0, 0);
  pdf.setFontType("normal");
  let menu_text = "Insights Dashboard  >  Consumer Information  >  Overview";
  if (this.props.reportType === "business") {
    if (nav === "overview") {
      menu_text = "Insights Dashboard  >  Business Information";
    } else if (nav === "map") {
      menu_text =
        "Insights Dashboard  >  Business Information  >  Geographic Traffic";
    } else if (nav === "pop" && popUrl) {
      menu_text = "Insights Dashboard  >  Business Information > " + popUrl;
    }
  } else {
    if (nav === "demographics") {
      menu_text =
        "Insights Dashboard  >  Consumer Information  >  Demographics";
    } else if (nav === "device") {
      menu_text = "Insights Dashboard  >  Consumer Information  >  Devices";
    } else if (nav === "pop") {
      menu_text =
        "Insights Dashboard  >  Consumer Information  >  Most Popular Pages";
    } else if (nav === "additional-demographics") {
      menu_text =
        "Insights Dashboard  >  Consumer Information  >  Additional Demographics and Behaviors";
    } else if (nav === "map") {
      menu_text =
        "Insights Dashboard  >  Consumer Information  >  Geographic Traffic";
    }
    if (nav === "pop" && popUrl) {
      menu_text = menu_text + "  >  " + popUrl;
    }
  }

  pdf.text(12, 35, menu_text);
  pdf.setFillColor(255);

  // pdf.setLineWidth(0.05)
  if (isBusiness) {
    if (!nav || nav === "overview") {
      BusinessOverview.call(
        this,
        pdf,
        dayRange,
        main,
        pageHeight,
        bu_name ? bu_name.trim() : clientName.trim(),
      );
    } else if (nav === "map") {
      // consumer map
      ConsumerMap.call(this, pdf, dayRange);
    } else if (nav === "pop" && popUrl) {
      BusinessTargetPopularPage.call(
        this,
        pdf,
        dayRange,
        main,
        pageHeight,
        bu_name ? bu_name.trim() : clientName.trim(),
      );
    }
    return;
  }
  if (!nav || nav === "overview") {
    ConsumerOverview.call(this, pdf, dayRange);
  } else if (nav === "demographics") {
    ConsumerDemographics.call(this, pdf, dayRange);
  } else if (nav === "device") {
    ConsumerDevice.call(this, pdf, dayRange);
  } else if (nav === "pop") {
    if (popUrl) {
      ConsumerPopularPage.call(this, pdf, dayRange, main, pageHeight, popUrl);
    } else {
      ConsumerPopular.call(this, pdf, dayRange);
    }
  } else if (nav === "additional-demographics") {
    ConsumerDemoBehaviors.call(this, pdf, dayRange);
  } else if (nav === "map") {
    // consumer map
    ConsumerMap.call(this, pdf, dayRange);
  }
}

function ConsumerMap(pdf, dayRange) {
  const fileName = createFilename.call(
    this,
    dayRange,
    this.props.reportType === "business" ? "business_map" : "consumer_map",
  );
  const pageWidth = 186;

  return Promise.all([mapHtml2CanvasWithgmap("overview-dashboard")]).then(
    parts => {
      let top = 42;
      for (let i = 0; i < parts.length; i++) {
        const { canvas } = parts[i];
        const h = (canvas.height * pageWidth) / canvas.width;
        if (top + h > 290) {
          pdf.addPage("a4", "p");
          top = 15;
        }
        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 12, top, 186, 0);
        top += h + 5;
      }
      oWidth = 0;
      addPdfFooter(pdf);
      pdf.save(fileName);
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    },
  );
}

function BusinessTargetPopularPage(
  pdf,
  dayRange,
  main,
  pageHeight,
  businessUnit,
) {
  const fileName = createFilename.call(
    this,
    dayRange,
    "Business",
    undefined,
    businessUnit,
  );
  const _width = main.offsetWidth;
  main.style.width = "1024px";
  setTimeout(() => {
    html2canvas(main, { logging: false }).then(canvas => {
      var serviceContact = document.getElementById("service-contact");
      if (serviceContact) serviceContact.style.display = "block";
      main.style.width = _width + "px";
      pdf.addImage(canvas.toDataURL(), "PNG", 12, 42, 186, 0);
      _addPdfFooter(pdf, pageHeight);
      pdf.save(fileName);
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    });
  }, 200);
}

function BusinessOverview(pdf, dayRange, main, pageHeight, businessUnit) {
  const fileName = createFilename.call(
    this,
    dayRange,
    "Business",
    undefined,
    businessUnit,
  );
  const _width = main.offsetWidth;
  main.style.width = "1024px";
  setTimeout(() => {
    html2canvas(main, { logging: false }).then(canvas => {
      var serviceContact = document.getElementById("service-contact");
      if (serviceContact) serviceContact.style.display = "block";
      main.style.width = _width + "px";
      pdf.addImage(canvas.toDataURL(), "PNG", 12, 42, 186, 0);
      _addPdfFooter(pdf, pageHeight);
      pdf.save(fileName);
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    });
  }, 200);
}

function ConsumerPopularPage(pdf, dayRange, main, pageHeight, popUrl) {
  const fileName = createFilename.call(this, dayRange, undefined, popUrl);
  const _width = main.offsetWidth;
  main.style.width = "1024px";
  setTimeout(() => {
    html2canvas(main, { logging: false }).then(canvas => {
      var serviceContact = document.getElementById("service-contact");
      serviceContact.style.display = "block";
      main.style.width = _width + "px";
      pdf.addImage(canvas.toDataURL(), "PNG", 12, 42, 186, 0);
      _addPdfFooter(pdf, pageHeight);
      pdf.save(fileName);
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    });
  }, 200);
}

function ConsumerOverview(pdf, dayRange) {
  const fileName = createFilename.call(this, dayRange, "Consumer");
  const pageWidth = 186;

  return Promise.all([
    mapHtml2Canvas("consumer-overflow-pdf-part1"),
    mapHtml2Canvas("consumer-overflow-pdf-part2"),
    mapHtml2Canvas("consumer-overflow-pdf-part3"),
    mapHtml2Canvas("consumer-overflow-pdf-part4"),
  ]).then(parts => {
    let top = 42;
    for (let i = 0; i < parts.length; i++) {
      const { canvas } = parts[i];
      const h = (canvas.height * pageWidth) / canvas.width;
      if (top + h > 290) {
        pdf.addPage("a4", "p");
        top = 15;
      }
      pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
      top += h + 5;
    }
    oWidth = 0;
    addPdfFooter(pdf);
    pdf.save(fileName);
    this.setState({
      showLoadingDialog: false,
      pdfCreating: false,
    });
  });
}

function ConsumerDemographics(pdf, dayRange) {
  const fileName = createFilename.call(this, dayRange, "Demographics");
  const pageWidth = 186;
  const pieEle = document.getElementsByClassName("_pie-chart");
  let pieWidth = 0;
  if (pieEle[0]) pieWidth = pieEle[0].getBoundingClientRect().width;
  function getWidth(list) {
    let ws = [];
    let eles = [];
    for (let i = 0; i < list.length; i++) {
      const ele = document.getElementById(list[i]);
      if (!ele) break;
      const { width } = ele.getBoundingClientRect();
      ws.push(width);
      eles.push(ele);
    }
    return Promise.all(eles.map(mapHtml2Canvas2)).then(res => {
      for (let i = 0; i < res.length; i++) {
        eles[i].style.width = ws[i] + "px";
      }
      return res;
    });
  }
  getWidth([
    "demograpic-part1",
    "demograpic-part2",
    "demograpic-part3",
    "demograpic-part4",
    "demograpic-part5",
  ])
    .then(res => {
      return mapHtml2Canvas("consumer-overflow-pdf-part1").then(head => {
        return [head, ...res];
      });
    })
    .then(parts => {
      const parts1 = [parts[1], parts[2]];
      const parts2 = [parts[3], parts[4], parts[5]];
      const _parts1 = [];
      const _parts2 = [];
      const p = [parts1, parts2];
      let offsetX = 12;
      const hCanvas = parts[0].canvas;
      pdf.addImage(hCanvas.toDataURL(), "PNG", offsetX, 42, pageWidth, 0);
      let t = 42 + (hCanvas.height * pageWidth) / hCanvas.width + 5;
      for (let x = 0; x < p.length; x++) {
        let top = t;
        for (let i = 0; i < p[x].length; i++) {
          const { canvas } = p[x][i];
          const h = (canvas.height * (pageWidth / 2)) / canvas.width;
          if (top + h > 290) {
            // pdf.addPage('a4', 'p');
            // top = 15;
            if (x === 0) _parts1.push(canvas);
            else _parts2.push(canvas);
          } else {
            pdf.addImage(canvas.toDataURL(), "PNG", offsetX, top, 90, 0);
            top += h + 5;
          }
        }
        offsetX += 95;
      }
      if (_parts1.length > 0 || _parts2.length > 0) {
        pdf.addPage("a4", "p");
        let offsetX = 12;
        const p2 = [_parts1, _parts2];
        for (let x = 0; x < p2.length; x++) {
          let top = 15;
          for (let i = 0; i < p2[x].length; i++) {
            const canvas = p2[x][i];
            const h = (canvas.height * (pageWidth / 2)) / canvas.width;
            pdf.addImage(canvas.toDataURL(), "PNG", offsetX, top, 90, 0);
            top += h + 5;
          }
          offsetX += 95;
        }
        offsetX += 95;
      }
      oWidth = 0;
      oWidth2 = 0;
      addPdfFooter(pdf);
      pdf.save(fileName);
      for (let i = 0; i < pieEle.length; i++) {
        pieEle[i].style.width = pieWidth + "px";
      }
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    });
}

function ConsumerDevice(pdf, dayRange) {
  const fileName = createFilename.call(this, dayRange, "Devices");
  const pageWidth = 186;
  const pieEle = document.getElementsByClassName("_pie-chart");
  let pieWidth = 0;
  if (pieEle[0]) pieWidth = pieEle[0].getBoundingClientRect().width;
  function getWidth(list) {
    let ws = [];
    let eles = [];
    for (let i = 0; i < list.length; i++) {
      const ele = document.getElementById(list[i]);
      if (!ele) break;
      const { width } = ele.getBoundingClientRect();
      ws.push(width);
      eles.push(ele);
    }
    return Promise.all(eles.map(mapHtml2Canvas2)).then(res => {
      for (let i = 0; i < res.length; i++) {
        eles[i].style.width = ws[i] + "px";
      }
      return res;
    });
  }
  getWidth(["device-pdf-part1", "device-pdf-part2", "device-pdf-part3"])
    .then(res => {
      return mapHtml2Canvas("consumer-overflow-pdf-part1").then(head => {
        return [head, ...res];
      });
    })
    .then(parts => {
      const parts1 = [parts[1], parts[2]];
      const parts2 = [parts[3]];
      const _parts1 = [];
      const _parts2 = [];
      const p = [parts1, parts2];
      let offsetX = 12;
      const hCanvas = parts[0].canvas;
      pdf.addImage(hCanvas.toDataURL(), "PNG", offsetX, 42, pageWidth, 0);
      let t = 42 + (hCanvas.height * pageWidth) / hCanvas.width + 5;
      for (let x = 0; x < p.length; x++) {
        let top = t;
        for (let i = 0; i < p[x].length; i++) {
          const { canvas } = p[x][i];
          const h = (canvas.height * (pageWidth / 2)) / canvas.width;
          if (top + h > 290) {
            // pdf.addPage('a4', 'p');
            // top = 15;
            if (x === 0) _parts1.push(canvas);
            else _parts2.push(canvas);
          } else {
            pdf.addImage(canvas.toDataURL(), "PNG", offsetX, top, 90, 0);
            top += h + 5;
          }
        }
        offsetX += 95;
      }
      if (_parts1.length > 0 || _parts2.length > 0) {
        pdf.addPage("a4", "p");
        let offsetX = 12;
        const p2 = [_parts1, _parts2];
        for (let x = 0; x < p2.length; x++) {
          let top = 15;
          for (let i = 0; i < p2[x].length; i++) {
            const canvas = p2[x][i];
            const h = (canvas.height * (pageWidth / 2)) / canvas.width;
            pdf.addImage(canvas.toDataURL(), "PNG", offsetX, top, 90, 0);
            top += h + 5;
          }
          offsetX += 95;
        }
        offsetX += 95;
      }
      oWidth = 0;
      oWidth2 = 0;
      addPdfFooter(pdf);
      pdf.save(fileName);
      for (let i = 0; i < pieEle.length; i++) {
        pieEle[i].style.width = pieWidth + "px";
      }
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    });
}

function ConsumerPopular(pdf, dayRange) {
  const fileName = createFilename.call(this, dayRange, "Popular");
  const pageWidth = 186;
  let oWidth = 0;
  let top = 42;
  const head = document.getElementById("consumer-overflow-pdf-part1");

  return new Promise(resolve => {
    oWidth = head.offsetWidth;
    head.style.width = "1024px";
    setTimeout(() => {
      html2canvas(head, { logging: false }).then(canvas => {
        resolve(canvas);
      });
    }, 200);
  })
    .then(head => {
      pdf.addImage(head.toDataURL(), "PNG", 12, top, 186, 0);
      top += (head.height * pageWidth) / head.width + 5;
      const parts = document.getElementsByClassName("popular-pdf-part");
      return Promise.all(
        Array.prototype.map.call(parts, it => {
          return html2canvas(it, { logging: false });
        }),
      );
    })
    .then(canvass => {
      pdf.setLineWidth(0.1);
      pdf.setDrawColor("#eeeff2");
      const startTop = top;
      pdf.line(12, startTop, 186 + 12, startTop);
      top += 5;
      for (let i = 0; i < canvass.length; i++) {
        // imageData, format, x, y, width, height, alias, compression, rotation
        pdf.addImage(canvass[i].toDataURL(), "PNG", 16, top, 178, 0);
        top += (canvass[i].height * 178) / canvass[i].width;
        if (i === 0) top += 5;
        if (top > 270) {
          pdf.line(12, startTop, 12, top);
          pdf.line(186 + 12, startTop, 186 + 12, top);
          pdf.line(12, top, 186 + 12, top);
          pdf.addPage("a4", "p");
          top = 15.5;
          pdf.setLineWidth(0.1);
          pdf.setDrawColor("#eeeff2");
          pdf.line(12, 15, 186 + 12, 15);
        }
      }
      pdf.line(12, 15, 12, top);
      pdf.line(186 + 12, 15, 186 + 12, top);
      pdf.line(12, top, 186 + 12, top);
      addPdfFooter(pdf);
      // pdf.stroke();
      pdf.save(fileName);
      head.style.width = oWidth + "px";
      this.setState({
        showLoadingDialog: false,
        pdfCreating: false,
      });
    });
}

function ConsumerDemoBehaviors(pdf, dayRange) {
  const fileName = createFilename.call(this, dayRange, "Demo_Behavior");
  const pageWidth = 186;

  return Promise.all([
    mapHtml2Canvas("consumer-overflow-pdf-part1"),
    mapHtml2Canvas("demo-behaviors-part1"),
    mapHtml2Canvas("demo-behaviors-part2"),
  ]).then(parts => {
    let top = 42;
    for (let i = 0; i < parts.length; i++) {
      const { canvas } = parts[i];
      const h = (canvas.height * pageWidth) / canvas.width;
      if (top + h > 290) {
        pdf.addPage("a4", "p");
        top = 15;
      }
      pdf.addImage(canvas.toDataURL(), "PNG", 12, top, 186, 0);
      top += h + 5;
    }
    oWidth = 0;
    addPdfFooter(pdf);
    pdf.save(fileName);
    this.setState({
      showLoadingDialog: false,
      pdfCreating: false,
    });
  });
}



// WEBPACK FOOTER //
// ./src/components/Insights/website/createPDF.js